import {CheckItemsManager} from '@app/modules/diagnostics/components/diagnostics/diagnostic-items/managers/check-items-manager';
import {Step} from '@app/modules/diagnostics/components/diagnostics/diagnostic-items/managers/step';
import {TestPassState, TestResponse, TestResponseCommands} from '@app/modules/diagnostics/components/diagnostics/diagnostic-items/models';
import {Observable} from 'rxjs';
import {Role} from '@app/modules/shared/data/constants';

export class SystemCheckManager extends CheckItemsManager {
  icon = 'system-g';
  name = 'System';

  constructor(userRole: Role) {
    super(userRole);
    this.steps.push(new SystemCheck(userRole));
  }
}

export class SystemCheck extends Step {
  constructor(userRole: Role) {
    super();
    this.userRole = userRole;
  }

  public name = 'CPU test';
  public title = 'Checking CPU performance...';
  public userRole: Role;

  doRunStep(): Observable<TestResponse> {
    return new Observable<TestResponse>(subscriber => {
      // setTimeout(() => {
        const startTime = new Date().getTime();
        this.getPrimes();
        this.getPrimes();
        const endTime = new Date().getTime();
        const elapsedMilliseconds = endTime - startTime;
        const system = this.resultCondition(elapsedMilliseconds);
        if (!system) {
          this.testResult.errorMassage = ' Your computer is slow, so it may lag or freeze. It may be possible to improve your experience somewhat; consult\n' +
            '    the classroom guide or ask tech support for suggestions, then retry this step. If you have done everything\n' +
            '    currently possible, skip this step for now. You may need to use a different computer in the future.';
          this.testResult.status = TestPassState.FAILED;
          this.testResult.text = elapsedMilliseconds + ' ms';
          this.testStatus = 'NO';
          subscriber.next(new TestResponse(TestResponseCommands.SHOW_ERROR));
        } else {
          this.testResult.status = TestPassState.PASSED;
          this.testStatus = 'OK';
          this.testResult.text = elapsedMilliseconds + ' ms';
          subscriber.next(new TestResponse(TestResponseCommands.NEXT));
        }
      // }, 1);
    });
  }

  getPrimes() {
    const max = Math.pow(2, 21);
    const sieve = [];
    let i;
    let j;
    const primes = [];
    for (i = 2; i <= max; ++i) {
      if (!sieve[i]) {
        // it has not been marked -- it is prime
        primes.push(i);
        // eslint-disable-next-line no-bitwise
        for (j = i << 1; j <= max; j += i) {
          sieve[j] = true;
        }
      }
    }
    return primes;
  }

 private resultCondition(result: number): boolean {
    if (this.userRole === Role.STAFF) {
      return result < 500;
    } else {
      return result < 1000;
    }
  }
}
